import { render, staticRenderFns } from "./AssignmentInfo.vue?vue&type=template&id=36d54ac9&scoped=true&"
import script from "./AssignmentInfo.vue?vue&type=script&lang=js&"
export * from "./AssignmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentInfo.vue?vue&type=style&index=0&id=36d54ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d54ac9",
  null
  
)

export default component.exports